<template>
  <section class="settings-section">
    <div v-if="title || description || $slots.header" class="settings-section-head">
      <slot name="header">
        <h2 v-if="title">{{ title }}</h2>
        <p v-if="description" class="settings-subtitle">{{ description }}</p>
      </slot>
    </div>
    <div class="settings-section-body">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  title?: string;
  description?: string;
}>();
</script>
